import { render, staticRenderFns } from "./SalutationSetting.vue?vue&type=template&id=00e36702&scoped=true"
import script from "./SalutationSetting.vue?vue&type=script&lang=ts"
export * from "./SalutationSetting.vue?vue&type=script&lang=ts"
import style0 from "./SalutationSetting.vue?vue&type=style&index=0&id=00e36702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e36702",
  null
  
)

export default component.exports